import type { QueryClient } from '@tanstack/react-query';

import { getQueryClient } from 'app/get-query-client';
import { portfolioBalanceKeys } from 'lib/queries/portfolioBalance';
import { portfolioCurrentKeys } from 'queries/portfolioCurrent';
import { userBalancesKeys } from 'queries/userBalances';

/** Refresh every event-contract balance representation shown in the UI. */
export function invalidatePredictionsBalanceQueries(qc: QueryClient = getQueryClient()) {
    qc.invalidateQueries({ queryKey: portfolioCurrentKeys.all });
    qc.invalidateQueries({ queryKey: portfolioBalanceKeys.all });
    qc.invalidateQueries({ queryKey: userBalancesKeys.all });
}
